import {
  AssetFilterScreen,
  AssetFilterScreenHandle,
  ColumnData,
  SlideAction,
  useSlideLayout,
  useSlidePanel,
} from '@gripp/shared-ui';
import { useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { HeaderResetButton } from '../../shared/components/headerResetButton';

export const AssetsFilterPage = () => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();
  const filterRef = useRef<AssetFilterScreenHandle>(null);

  const column = useMemo<ColumnData>(
    () => ({
      title: 'assets.menu.title',
      mainComponent: (
        <AssetFilterScreen
          ref={filterRef}
          mode="page"
          isVisible={true}
          bottomBar={() => <></>}
        />
      ),
      headerComponent: (
        <HeaderResetButton onReset={() => filterRef.current?.onReset()} />
      ),
      showBackButton: true,
      onBackButtonPress: async () => {
        await onSlideChange(SlideAction.SINGLE);
        navigate('/assets');
      },
    }),
    [navigate, onSlideChange]
  );

  useSlidePanel('right', column, [column]);

  return null;
};
